var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { grey } from '@platform/front-ui';
import { css } from 'styled-components';
export default function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n        font-size: 0.875rem;\n        font-weight: 500;\n        line-height: 1.25rem;\n    "], ["\n        color: ", ";\n        font-size: 0.875rem;\n        font-weight: 500;\n        line-height: 1.25rem;\n    "])), grey[900]).join('');
}
var templateObject_1;
